<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green">
            <h2 class="title title-align text-center">
                步數計算機
            </h2>
            <div class="contentCenter" v-show="!showResult">
                <div class="green">
                    <p>你平時需要搭乘汽車幾公里？：</p>
                    <select v-model="selectDistance" class="selectStyle">
                        <option v-for="(distance, index) in distanceList" :key="index" :value="distance">{{ distance }}
                        </option>
                    </select>
                </div>
                <button class="calculateStyle" @click.prevent="getResult">計算</button>
            </div>
            <!-- 計算結果 -->
            <div v-for="(result, index) in resultList" :key="index">
                <div v-if="selectDistance === result.val && showResult">
                    <StepsResult :km="result.km" :co2="result.co2" :walkByKm="result.walkByKm"
                        :walkBySteps="result.walkBySteps" @show-question="showQuestion" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import StepsResult from '@/components/StepsResult';

export default {
    data() {
        return {
            showResult: false,
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            selectDistance: '3公里',
            distanceList: ['3公里', '5公里', '7公里', '9公里'],
            resultList: [
                {
                    val: '3公里',
                    km: 3,
                    co2: 0.44,
                    walkByKm: 1.873,
                    walkBySteps: '3,122',
                },
                {
                    val: '5公里',
                    km: 5,
                    co2: 0.74,
                    walkByKm: 3.122,
                    walkBySteps: '5,204',
                },
                {
                    val: '7公里',
                    km: 7,
                    co2: 1.036,
                    walkByKm: 4.371,
                    walkBySteps: '7,286',
                },
                {
                    val: '9公里',
                    km: 9,
                    co2: 1.332,
                    walkByKm: 5.578,
                    walkBySteps: '9,299',
                },
            ],
        };
    },
    methods: {
        getResult() {
            this.showResult = true;
        },
        showQuestion(val) {
            this.showResult = val;
        },
    },
    components: {
        Banner,
        Breadcrumb,
        StepsResult,
    },
    mixins: [coreMixin],
};
</script>

<style scoped>
.selectStyle {
    width: 100%;
}
</style>
